(() => {
  if (window.__omCartBenefitProgressInitialized) {
    return;
  }

  window.__omCartBenefitProgressInitialized = true;

  const THRESHOLDS = {
    delivery: 99900,
    om5: 129900,
    om10: 199900,
    om20: 349900
  };

  let refreshTimer = null;

  function formatMoney(paise) {
    const amount = Math.max(0, Math.ceil(paise / 100));

    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(amount);
  }

  function calculateProgress(total) {
    const {
      delivery,
      om5,
      om10,
      om20
    } = THRESHOLDS;

    let progress = 0;

    if (total < delivery) {
      progress = (total / delivery) * 25;
    } else if (total < om5) {
      progress =
        25 +
        ((total - delivery) / (om5 - delivery)) * 25;
    } else if (total < om10) {
      progress =
        50 +
        ((total - om5) / (om10 - om5)) * 25;
    } else if (total < om20) {
      progress =
        75 +
        ((total - om10) / (om20 - om10)) * 25;
    } else {
      progress = 100;
    }

    return Math.min(100, Math.max(0, progress));
  }

  function getBenefitState(total) {
    if (total < THRESHOLDS.delivery) {
      return {
        message:
          `Add ${formatMoney(
            THRESHOLDS.delivery - total
          )} more to unlock complimentary delivery.`,
        code: null
      };
    }

    if (total < THRESHOLDS.om5) {
      return {
        message:
          `Complimentary delivery unlocked. Add ${formatMoney(
            THRESHOLDS.om5 - total
          )} more to unlock 5% off.`,
        code: null
      };
    }

    if (total < THRESHOLDS.om10) {
      return {
        message:
          `5% off is available. Add ${formatMoney(
            THRESHOLDS.om10 - total
          )} more to unlock 10% off.`,
        code: 'OM5'
      };
    }

    if (total < THRESHOLDS.om20) {
      return {
        message:
          `10% off is available. Add ${formatMoney(
            THRESHOLDS.om20 - total
          )} more to unlock 20% off.`,
        code: 'OM10'
      };
    }

    return {
      message:
        'Your highest cart-value benefit is now available.',
      code: 'OM20'
    };
  }

  function updateProgress(total) {
    const root = document.querySelector(
      '[data-om-cart-benefits]'
    );

    if (!root) {
      return;
    }

    const progress = calculateProgress(total);
    const state = getBenefitState(total);

    const message = root.querySelector(
      '[data-om-benefit-message]'
    );

    const progressElement = root.querySelector(
      '[data-om-benefit-progress]'
    );

    const fill = root.querySelector(
      '[data-om-benefit-fill]'
    );

    const eligible = root.querySelector(
      '[data-om-benefit-eligible]'
    );

    const codeElement = root.querySelector(
      '[data-om-benefit-code]'
    );

    const copyButton = root.querySelector(
      '[data-om-cart-copy-code]'
    );

    root.dataset.cartTotal = String(total);

    if (message) {
      message.textContent = state.message;
    }

    if (fill) {
      fill.style.width = `${progress}%`;
    }

    if (progressElement) {
      progressElement.setAttribute(
        'aria-valuenow',
        String(Math.round(progress))
      );
    }

    root
      .querySelectorAll('[data-om-benefit-milestone]')
      .forEach((milestone) => {
        const threshold = Number(
          milestone.dataset.threshold
        );

        milestone.classList.toggle(
          'is-unlocked',
          total >= threshold
        );
      });

    if (
      state.code &&
      eligible &&
      codeElement &&
      copyButton
    ) {
      eligible.hidden = false;
      codeElement.textContent = state.code;
      copyButton.dataset.code = state.code;
      copyButton.textContent = 'Copy Code';
      copyButton.classList.remove('is-copied');
    } else if (eligible) {
      eligible.hidden = true;
    }
  }

  async function fetchCart() {
    const shopRoot =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    const response = await fetch(
      `${shopRoot}cart.js`,
      {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error('Unable to retrieve cart.');
    }

    return response.json();
  }

  async function refreshProgress() {
    try {
      const cart = await fetchCart();
      updateProgress(cart.total_price);
    } catch (error) {
      console.error(
        'OM Cart Benefits:',
        error
      );
    }
  }

  function scheduleRefresh(delay = 500) {
    window.clearTimeout(refreshTimer);

    refreshTimer = window.setTimeout(
      refreshProgress,
      delay
    );
  }

  async function copyCode(button) {
    const code = button.dataset.code;

    if (!code) {
      return;
    }

    try {
      if (
        navigator.clipboard &&
        window.isSecureContext
      ) {
        await navigator.clipboard.writeText(code);
      } else {
        const textarea =
          document.createElement('textarea');

        textarea.value = code;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';

        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        textarea.remove();
      }

      button.textContent = 'Copied ✓';
      button.classList.add('is-copied');

      window.setTimeout(() => {
        button.textContent = 'Copy Code';
        button.classList.remove('is-copied');
      }, 1800);
    } catch (error) {
      console.error(
        'OM Cart Benefits: Unable to copy code.',
        error
      );
    }
  }

  document.addEventListener('click', (event) => {
    const copyButton = event.target.closest(
      '[data-om-cart-copy-code]'
    );

    if (copyButton) {
      event.preventDefault();
      copyCode(copyButton);
      return;
    }

    if (
      event.target.closest(
        'quantity-input, cart-remove-button, ' +
        '.quantity__button, [name="updates[]"], ' +
        '[data-cart-add], .quick-add__submit'
      )
    ) {
      scheduleRefresh(900);
    }
  });

  document.addEventListener('change', (event) => {
    if (
      event.target.matches(
        '[name="updates[]"], .quantity__input'
      )
    ) {
      scheduleRefresh(900);
    }
  });

  document.addEventListener(
    'cart:updated',
    () => scheduleRefresh(100)
  );

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      const root = document.querySelector(
        '[data-om-cart-benefits]'
      );

      if (root) {
        updateProgress(
          Number(root.dataset.cartTotal || 0)
        );
      }

      scheduleRefresh(50);

      const cartItems =
        document.querySelector('cart-items');

      if (cartItems) {
        const observer = new MutationObserver(() => {
          scheduleRefresh(350);
        });

        observer.observe(cartItems, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }
    }
  );
})();